import { getIndexedLocationFilters } from '@atc/bonnet-reference';
import { brands } from '@atc/brand';

import additionalCrawlPaths from '@/config/crawlAdditional.json';
import additionalCrawlPathsFord from '@/config/crawlAdditionalFord.json';
import additionalCrawlPathsKbb from '@/config/crawlAdditionalKbb.json';

import srpAdditionalCrawlPathsDuck from '@/ducks/srp/srpAdditionalCrawlPathsDuck';

const addConditionToAdditionalData = (brand, sourceData, query) => {
    if (brand !== brands.KBB_BRAND) return sourceData;

    const listingType = query.listingType?.toLowerCase() || query.allListingType;
    const isIgnored = ['NEW', 'CERTIFIED'].includes(query.listingType);
    const hasCondition = (link) => ['used', 'all'].some((type) => link.includes(`${type}`));

    const addConditionToLink = (item) => {
        if (isIgnored || hasCondition(item.link)) return item;
        return {
            ...item,
            link: item.link.replace('/cars-for-sale/', `/cars-for-sale/${listingType}/`),
        };
    };

    return {
        ...sourceData,
        pricingData: {
            ...sourceData.pricingData,
            crawlLinks: sourceData.pricingData.crawlLinks.map(addConditionToLink),
        },
        stylesData: {
            ...sourceData.stylesData,
            crawlLinks: sourceData.stylesData.crawlLinks.map(addConditionToLink),
        },
    };
};

// handle additional crawl path
const additionalData = (brand) => {
    switch (brand) {
        case brands.KBB_BRAND:
            return additionalCrawlPathsKbb;
        case brands.FORD_BRAND:
            return additionalCrawlPathsFord;
        default:
            return additionalCrawlPaths;
    }
};

const dispatchAdditionalCrawlPaths = (brand, query, disableNonCitiesCrawlpath, dispatch, additionalCrawlPathData) => {
    if (query.zip || disableNonCitiesCrawlpath || brand === brands.CAR_AND_DRIVER) {
        dispatch(srpAdditionalCrawlPathsDuck.creators.reset());
    } else {
        dispatch(srpAdditionalCrawlPathsDuck.creators.setKeys(additionalCrawlPathData));
    }
};

const shouldRenderAllCrawlPaths = (isAtcBrand, onlyContainsMakeOrMakeModel, indexedZip, isNational, isHighIndexable) => {
    if (isAtcBrand && !onlyContainsMakeOrMakeModel) {
        return indexedZip && (isNational || !isHighIndexable);
    }
    return indexedZip || isNational;
};

const determineIndexedZip = async (isIndexedZip, query, brand, locationIndexValue) => {
    let indexedZip = true;
    let updatedLocationIndexValue = locationIndexValue;

    if (isIndexedZip !== undefined) {
        indexedZip = isIndexedZip;
    } else if (query.zip) {
        const { success, payload } = await getIndexedLocationFilters(query, brand, locationIndexValue);
        updatedLocationIndexValue = payload?.locationIndexPriority || 'high';
        if (!success) {
            indexedZip = false;
        }
    }

    return { indexedZip, locationIndexValue: updatedLocationIndexValue };
};

const getAdditionalCitiesCrawlPathQuery = (query, shouldAdd = true) => {
    if (!shouldAdd) {
        return {};
    }

    return {
        sellerType: query.sellerType,
        fuelTypeGroup: query.fuelTypeGroup,
        driveGroup: query.driveGroup,
        engineCode: query.engineCode,
        extColorSimple: query.extColorSimple,
    };
};

const shouldIncludeLink = (path, storeKey, srpHighIndexURLsSet) => {
    const hasSrpHighIndexURLsSet = srpHighIndexURLsSet && srpHighIndexURLsSet.size > 0;

    if (!hasSrpHighIndexURLsSet) {
        return true;
    }

    if (storeKey === 'citiesData') {
        const urlWithoutCityState = path.substring(0, path.lastIndexOf('/'));
        return srpHighIndexURLsSet.has(urlWithoutCityState);
    }

    return srpHighIndexURLsSet.has(path);
};

export {
    addConditionToAdditionalData,
    additionalData,
    dispatchAdditionalCrawlPaths,
    shouldRenderAllCrawlPaths,
    determineIndexedZip,
    getAdditionalCitiesCrawlPathQuery,
    shouldIncludeLink,
};
